<template>
    <header>
        <div class="header-content header-mobile">
            <div class="header-top container-fluid no-shadow">
                <div class="module container width-5">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="section-title mb-0">
                            <button class="button button-text">
                                <h5 class="d-flex">
                                    <div class="icon mr-3" @click="$router.go(-1)">
                                        <svg width="25" version="1.0" viewBox="0 0 470 342" xmlns="http://www.w3.org/2000/svg">
                                            <g transform="translate(0 342) scale(.1 -.1)">
                                                <path d="m1630 3407c-27-8-212-187-813-786-523-522-784-789-797-817-26-53-26-135 0-188 28-58 1551-1579 1602-1601 52-21 140-19 186 4 106 55 152 182 103 286-13 27-205 225-590 610l-571 570 3795 10 45 25c24 14 58 45 75 68 27 40 30 51 30 122s-3 82-30 122c-17 23-51 54-75 68l-45 25-3795 10 566 565c311 311 573 581 583 600 46 89 33 178-38 250-63 66-140 85-231 57z"></path>
                                            </g>
                                        </svg>
                                    </div> Settings
                                </h5>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </header>
    <section id="main-wrapper" style="padding-top: 49px; padding-bottom: 123px;">
        <div class="container-fluid section-small">
            <div class="module container width-5">
                <div class="row-list-mb15">
                    <div class="se-co-box">
                        <ul class="sc-bo-list">
                            <li><router-link class="sc-bo-select" to="/settings/edit-profile">Edit Profile</router-link></li>
                            <li><a class="sc-bo-select" href="#"><span>Language</span><span class="sb-se-title">English</span></a></li>
                        </ul>
                    </div>
                    <div class="se-co-box">
                        <ul class="sc-bo-list">
                            <li>
                                <div class="sc-bo-opt">
                                    <div>Push Notifications</div>
                                    <label class="com_toggle-btn">
                                        <input type="checkbox" name="" value="" checked>
                                        <div class="icon"></div>
                                    </label>
                                </div>
                            </li>
                            <li><router-link class="sc-bo-select" to="/settings/notification-preferences">Notification Preferences</router-link></li>
                        </ul>
                    </div>
                    <div class="se-co-box">
                        <ul class="sc-bo-list">
                            <li><router-link class="sc-bo-select" to="/settings/general">General</router-link></li>
                            <li><router-link class="sc-bo-select" to="/settings/security">Security</router-link></li>
                        </ul>
                    </div>
                    <div class="se-co-box">
                        <ul class="sc-bo-list">
                            <li><a class="sc-bo-select" href="#">Privacy Policy</a></li>
                            <li><a class="sc-bo-select" href="#">Community Guidelines</a></li>
                            <li>
                                <div class="sc-bo-set"><span>App Version</span> <span class="sb-se-title">1.1</span></div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
export default{};
</script>